import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  businessCenterList: { loading: false, data: null, error: null },
  createbusinessCenter: { loading: false, data: null, error: null },
  updatebusinessCenter: { loadinf: false, data: null, error: null },

  floorBookingDetailsList: { loading: false, data: null, error: null },
  floorSeatDetailsList: { loading: false, data: null, error: null },
  floorSuiteDetailsList: { loading: false, data: null, error: null },
  /** Location-wide suite availability with dates (multi-suite / cross-floor) */
  locationSuiteAvailability: { loading: false, data: null, error: null },
  allfloorBookingDetailsList: { loading: false, data: null, error: null },
  updateWorkstationStatus: { loading: false, data: null, error: null },
  businessCenterStatus: { loading: false, data: null, error: null },
};

export const BusinessCenter = createSlice({
  name: "businessCenter",
  initialState,
  reducers: {
    fetchbusinessCenterListRequest: (businessCenter, action) => {
      businessCenter.businessCenterList.loading = true;
      businessCenter.businessCenterList.error = null;
    },
    fetchbusinessCenterListSuccess: (businessCenter, action) => {
      businessCenter.businessCenterList.data = action.payload;
      businessCenter.businessCenterList.loading = false;
      businessCenter.businessCenterList.error = null;
    },
    fetchbusinessCenterListFaliure: (businessCenter, action) => {
      businessCenter.businessCenterList.data = null;
      businessCenter.businessCenterList.loading = false;
      businessCenter.businessCenterList.error = action.payload;
    },

    createBusinessCenterRequest: (state, action) => {
      state.createbusinessCenter.loading = true;
      state.createbusinessCenter.error = null;
    },
    createBusinessCenterSuccess: (state, action) => {
      state.createbusinessCenter.data = action.payload;
      state.createbusinessCenter.loading = false;
      state.createbusinessCenter.error = null;
      state.businessCenterList = addNewBusinessCenterSuccess(action.payload, {
        ...state.businessCenterList,
      });
    },
    createBusinessCenterFailure: (state, action) => {
      state.createbusinessCenter.data = null;
      state.createbusinessCenter.loading = false;
      state.createbusinessCenter.error = action.payload;
    },

    //FloorBooking Details
    fetchFloorBookingDetailsListRequest: (businessCenter, action) => {
      businessCenter.floorBookingDetailsList.loading = true;
      businessCenter.floorBookingDetailsList.error = null;
    },
    fetchFloorBookingDetailsListSuccess: (businessCenter, action) => {
      businessCenter.floorBookingDetailsList.data = action.payload;
      businessCenter.floorBookingDetailsList.loading = false;
      businessCenter.floorBookingDetailsList.error = null;
    },
    fetchFloorBookingDetailsListFaliure: (businessCenter, action) => {
      businessCenter.floorBookingDetailsList.data = null;
      businessCenter.floorBookingDetailsList.loading = false;
      businessCenter.floorBookingDetailsList.error = action.payload;
    },

    //FloorSeat Details
    fetchFloorSeatDetailsListRequest: (businessCenter, action) => {
      businessCenter.floorSeatDetailsList.loading = true;
      businessCenter.floorSeatDetailsList.error = null;
    },
    fetchFloorSeatDetailsListSuccess: (businessCenter, action) => {
      businessCenter.floorSeatDetailsList.data = action.payload;
      businessCenter.floorSeatDetailsList.loading = false;
      businessCenter.floorSeatDetailsList.error = null;
    },
    fetchFloorSeatDetailsListFaliure: (businessCenter, action) => {
      businessCenter.floorSeatDetailsList.data = null;
      businessCenter.floorSeatDetailsList.loading = false;
      businessCenter.floorSeatDetailsList.error = action.payload;
    },

    //FloorSuite Details
    fetchFloorSuiteDetailsListRequest: (businessCenter, action) => {
      businessCenter.floorSuiteDetailsList.loading = true;
      businessCenter.floorSuiteDetailsList.error = null;
    },
    fetchLocationSuiteDetailsListRequest: (businessCenter, action) => {
      businessCenter.floorSuiteDetailsList.loading = true;
      businessCenter.floorSuiteDetailsList.error = null;
    },
    fetchSuitesByFloorListRequest: (businessCenter, action) => {
      businessCenter.floorSuiteDetailsList.loading = true;
      businessCenter.floorSuiteDetailsList.error = null;
    },
    fetchFloorSuiteDetailsListSuccess: (businessCenter, action) => {
      businessCenter.floorSuiteDetailsList.data = action.payload;
      businessCenter.floorSuiteDetailsList.loading = false;
      businessCenter.floorSuiteDetailsList.error = null;
    },
    fetchFloorSuiteDetailsListFaliure: (businessCenter, action) => {
      businessCenter.floorSuiteDetailsList.data = null;
      businessCenter.floorSuiteDetailsList.loading = false;
      businessCenter.floorSuiteDetailsList.error = action.payload;
    },

    fetchLocationSuiteAvailabilityRequest: (businessCenter) => {
      businessCenter.locationSuiteAvailability.loading = true;
      businessCenter.locationSuiteAvailability.error = null;
    },
    fetchLocationSuiteAvailabilitySuccess: (businessCenter, action) => {
      businessCenter.locationSuiteAvailability.data = action.payload;
      businessCenter.locationSuiteAvailability.loading = false;
      businessCenter.locationSuiteAvailability.error = null;
    },
    fetchLocationSuiteAvailabilityFailure: (businessCenter, action) => {
      businessCenter.locationSuiteAvailability.data = null;
      businessCenter.locationSuiteAvailability.loading = false;
      businessCenter.locationSuiteAvailability.error = action.payload;
    },

    fetchAllFloorBookingDetailsListRequest: (businessCenter, action) => {
      businessCenter.allfloorBookingDetailsList.loading = true;
      businessCenter.allfloorBookingDetailsList.error = null;
    },
    fetchAllFloorBookingDetailsListSuccess: (businessCenter, action) => {
      businessCenter.allfloorBookingDetailsList.data = action.payload;
      businessCenter.allfloorBookingDetailsList.loading = false;
      businessCenter.allfloorBookingDetailsList.error = null;
    },
    fetchAllFloorBookingDetailsListFaliure: (businessCenter, action) => {
      businessCenter.allfloorBookingDetailsList.data = null;
      businessCenter.allfloorBookingDetailsList.loading = false;
      businessCenter.allfloorBookingDetailsList.error = action.payload;
    },
    // change business center status
    updateWorkstationStatusRequest: (businessCenter, action) => {
      businessCenter.updateWorkstationStatus.loading = true;
      businessCenter.updateWorkstationStatus.error = null;
    },
    updateWorkstationStatusSuccess: (businessCenter, action) => {
      businessCenter.updateWorkstationStatus.data = action.payload;
      businessCenter.updateWorkstationStatus.loading = false;
      businessCenter.updateWorkstationStatus.error = null;
      businessCenter.businessCenterList = updateWorkstationStatus(
        action.payload,
        {
          ...businessCenter.businessCenterList,
        }
      );
    },
    updateWorkstationStatusFailure: (businessCenter, action) => {
      businessCenter.updateWorkstationStatus.data = null;
      businessCenter.updateWorkstationStatus.loading = false;
      businessCenter.updateWorkstationStatus.error = action.payload;
    },
    // update businesss center status
    updateBusinessCenterStatusRequest: (businessCenter, action) => {
      businessCenter.businessCenterStatus.loading = true;
      businessCenter.businessCenterStatus.error = null;
      businessCenter.businessCenterStatus.data = null;
    },
    updateBusinessCenterStatusSuccess: (businessCenter, action) => {
      businessCenter.businessCenterStatus.data = action.payload;
      businessCenter.businessCenterStatus.loading = false;
      businessCenter.businessCenterStatus.error = null;
      businessCenter.businessCenterList = updateBusinessCenterStatus(
        action.payload,
        {
          ...businessCenter.businessCenterList,
        }
      );
    },
    updateBusinessCenterStatusFailure: (businessCenter, action) => {
      businessCenter.businessCenterStatus.data = null;
      businessCenter.businessCenterStatus.loading = false;
      businessCenter.businessCenterStatus.error = action.payload;
    },
    // reset initial states when onclick event is trigged 
    resetFloorBookingDetailsList: (businessCenter, action) => {
      businessCenter.floorBookingDetailsList.loading = true;
      businessCenter.floorBookingDetailsList.error = null;
      businessCenter.floorBookingDetailsList.data = null;
    },
    resetAllFloorBookingDetailsList: (businessCenter, action) => {
      businessCenter.allfloorBookingDetailsList.loading = true;
      businessCenter.allfloorBookingDetailsList.error = null;
      businessCenter.allfloorBookingDetailsList.data = null;
    },
  },
});

function addNewBusinessCenterSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

function updateWorkstationStatus(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}
function updateBusinessCenterStatus(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}
export const {
  fetchbusinessCenterListRequest,
  fetchbusinessCenterListSuccess,
  fetchbusinessCenterListFaliure,
  createBusinessCenterRequest,
  createBusinessCenterSuccess,
  createBusinessCenterFailure,

  fetchFloorBookingDetailsListRequest,
  fetchFloorBookingDetailsListSuccess,
  fetchFloorBookingDetailsListFaliure,

  fetchFloorSeatDetailsListRequest,
  fetchFloorSeatDetailsListSuccess,
  fetchFloorSeatDetailsListFaliure,

  fetchFloorSuiteDetailsListRequest,
  fetchFloorSuiteDetailsListSuccess,
  fetchFloorSuiteDetailsListFaliure,
  fetchLocationSuiteDetailsListRequest,
  fetchSuitesByFloorListRequest,

  fetchLocationSuiteAvailabilityRequest,
  fetchLocationSuiteAvailabilitySuccess,
  fetchLocationSuiteAvailabilityFailure,

  fetchAllFloorBookingDetailsListRequest,
  fetchAllFloorBookingDetailsListSuccess,
  fetchAllFloorBookingDetailsListFaliure,
  resetAllFloorBookingDetailsList,

  updateWorkstationStatusRequest,
  updateWorkstationStatusSuccess,
  updateWorkstationStatusFailure,

  updatebusinessCenterStatusRequest,
  updatebusinessCenterStatusSuccess,
  updatebusinessCenterStatusFaliure,

  updateBusinessCenterStatusRequest,
  updateBusinessCenterStatusSuccess,
  updateBusinessCenterStatusFailure,
  resetFloorBookingDetailsList,
} = BusinessCenter.actions;

export const getbusinessCenterListState = (store) =>
  store.businessCenter?.businessCenterList;
export const getbusinessCenterCreateState = (store) =>
  store.businessCenter?.createbusinessCenter;
export const getFloorBookingDetailsListState = (store) =>
  store.businessCenter?.floorBookingDetailsList;
export const getFloorSeatDetailsListState = (store) =>
  store.businessCenter?.floorSeatDetailsList;
export const getFloorSuiteDetailsListState = (store) =>
  store.businessCenter?.floorSuiteDetailsList;
export const getLocationSuiteAvailabilityState = (store) =>
  store.businessCenter?.locationSuiteAvailability;
export const getAllFloorBookingDetailsListState = (store) =>
  store.businessCenter?.allfloorBookingDetailsList;
export const getFloorPlanDetailsState = (store) =>
  store.businessCenter?.floorPlanDetails;
export const getStatusWorkstationState = (store) =>
  store.businessCenter?.updateWorkstationStatus;
export const getStatusBusinessCenterState = (store) =>
  store.businessCenter?.businessCenterStatus;

export default BusinessCenter.reducer;
